import React, { forwardRef, useState, useEffect, useContext } from 'react'
import {
  Dialog,
  DialogContent,
  IconButton,
  Grow,
  Box,
  Typography,
  Button,
  Grid,
} from '@mui/material'
import { motion } from 'framer-motion'
import { Close } from '@mui/icons-material'

import { AnimatePresence } from 'framer-motion'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { selectData } from 'layouts/onboarding'
import { callZapier } from 'utils/zapier/callZapier'
import email from 'assets/images/email.png'
import ScrollingLogos from 'components/ScrollingLogos'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function AuthHelp({ open, setOpen, onClose }) {
  const [direction, setDirection] = useState(1)

  const [name, setName] = useState('')
  const [referralEmail, setReferralEmail] = useState('')
  const [referralPhone, setReferralPhone] = useState('')
  const [isDisabled, setIsDisabled] = useState(true)
  const [sent, setSent] = useState(false)

  useEffect(() => {
    if (
      name != '' &&
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(referralEmail)
    ) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [name, referralEmail, referralPhone])

  const handleSubmit = () => {
    const referral = {
      name: name || 'No Name',
      email: referralEmail || 'No Email',
      phone: referralPhone || 'No Phone',
    }

    callZapier({
      user: {
        email: 'help@goparco.com',
      },
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/u3t928j/',
      payload: {
        helpUser: { ...referral },
      },
      notificationMessage: `A message has been sent to the PARCO team - we will be in touch shortly!`,
      sendNotification: true,
    })

    setSent(true)
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'sm'}
        PaperProps={{
          sx: {
            overflow: { xs: 'auto', sm: 'visible' },
            margin: '16px',
            width: 'calc(100% - 32px)',
          },
        }}
      >
        <Box
          sx={{
            justifyContent: 'space-between',
            position: 'relative',
            display: 'flex',
            top: { xs: 8, sm: -48 },
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 0,
              right: { xs: 8, sm: 0 },
              color: '#fff',
              zIndex: 1,
              backgroundColor: '#000',
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <DialogContent sx={{ overflow: 'visible' }}>
          <motion.div
            key="accounts"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <AnimatePresence mode="wait" custom={direction}>
              <motion.div
                custom={direction}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.3 }}
                style={{
                  position: 'relative',
                  width: '100%',
                }}
              >
                <Box
                  px={{ xs: 0, sm: 6 }}
                  pt={{ xs: 4, sm: 6 }}
                  pb={{ xs: 2, sm: 6 }}
                >
                  <Typography
                    variant="headerTitle"
                    color="#262627"
                    textAlign="center"
                    display="block"
                  >
                    Get Login Help!
                  </Typography>
                  <Typography
                    variant="body1"
                    mt={1}
                    color="#495057"
                    textAlign="center"
                  >
                    Submit the form below and a PARCO team member will reach out
                    as soon as possible.
                  </Typography>
                  <Grid container mt={0} spacing={2} justifyContent={'center'}>
                    <Grid item xs={12}>
                      {renderMuiFormField({
                        autoFocus: false,
                        required: true,
                        label: 'Your Name',
                        placeholder: 'Fox Mulder',
                        value: name,
                        onChange: setName,
                      })}
                    </Grid>
                    <Grid item xs={12}>
                      {renderMuiFormField({
                        autoFocus: false,
                        id: 'referralPhone',
                        label: 'Phone Number',
                        placeholder: '',
                        inputType: 'tel',
                        value: referralPhone,
                        onChange: setReferralPhone,
                      })}
                    </Grid>
                    <Grid item xs={12}>
                      {renderMuiFormField({
                        autoFocus: false,
                        required: true,
                        id: 'referralEmail',
                        label: 'Email Address',
                        placeholder: 'foxmulder@gmail.com',
                        inputType: 'email',
                        value: referralEmail,
                        onChange: setReferralEmail,
                      })}
                    </Grid>
                  </Grid>
                  <Box
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    mt={5}
                  >
                    <Button
                      variant="contained"
                      disabled={isDisabled}
                      onClick={handleSubmit}
                      sx={{
                        padding: '8px 24px',
                        backgroundColor: '#2370ED',
                        border: '2px solid #2370ED',
                        color: '#fff',
                        boxShadow: 'none',
                        borderRadius: '100px',
                        textTransform: 'capitalize',
                        fontWeight: 600,
                        fontSize: '18px',
                        lineHeight: 1.5,
                        '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                          transform: 'none',
                          backgroundColor: '#1c59bd',
                          borderColor: '#1c59bd',
                          boxShadow: 'none',
                        },
                        '&:disabled': {
                          borderColor: 'rgba(0,0,0,0)',
                        },
                      }}
                    >
                      Request Help
                    </Button>
                  </Box>
                </Box>
              </motion.div>
            </AnimatePresence>
          </motion.div>
        </DialogContent>
      </Dialog>
    </>
  )
}
